import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getOpportunityList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/findOpportunityAll", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getMajorList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: "/dictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  insertOpportunityProgramme({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/insert", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateOpportunityProgramme({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/update", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selOpportunityProgrammeListXk({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/findAllXk", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selOpportunityProgrammeList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/findAll", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selOpportunityProgrammeById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/selectById", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  sendScheme({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: "/artOpportunityPoint/sendScheme",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  deleteOpportunityProgramme({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/delete", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveLeaveMessage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/saveLeaveMessage", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateSchemeDesignThought({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post("/artOpportunityPoint/updateSchemeDesignThought", params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  export({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get("/artOpportunityPoint/export", {params}).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
}
